import { Pagination } from "./common";
import { API_URL } from "../config";

export interface ChannelInfo {
    title: string;
    img: string;
    details: string;
}

export interface Video {
    title: string;
    href: string;
    img: string;
    duration: string;
    dateDiff: string;
}

export interface VideosResult {
    pagination: Pagination;
    channelInfo: ChannelInfo;
    videos: Video[];
}

export const orders = [
    "watched-recently",
    "new",
    "add-date",
    "most-viewed",
] as const;
export type Order = (typeof orders)[number];
export async function videos(
    channelURL: string,
    order: Order = "new",
    page: number = 0
): Promise<VideosResult> {
    return await (
        await fetch(
            API_URL +
                "/videos" +
                channelURL +
                "?" +
                new URLSearchParams({ p: page.toString(), order }).toString()
        )
    ).json();
}
